// extracted by mini-css-extract-plugin
module.exports = {"infotext-tooltip":"infoTextTooltip_infotext-tooltip__32s0n","infotext-tooltip__span-tooltip":"infoTextTooltip_infotext-tooltip__span-tooltip__164Gu"};